// VNEC v9 — pages/phu-luc.js
// Phụ lục HĐ — saves to plhd table.
// v9.1: Parent HĐ query từ hop_dong (không phải plhd), thêm Loại CP cho items.
import { supabase, getCurrentUser, submitForApproval } from '../lib/supabase.js';
import { formatVND, parseVND, esc } from '../lib/forms.js';
import { getNextMaPL } from '../lib/naming.js';

let _state = { rows: [], user: null, loaiCPList: [] };

export function renderPhuLuc() {
  window.__pageInit = initPhuLuc;
  return `
    <div class="crud-wrap">
      <div class="page-hd">
        <h2>Phụ lục Hợp đồng (PL)</h2>
        <div>
          <button class="btn btn-primary btn-sm" id="pl-new">+ Tạo phụ lục</button>
          <button class="btn btn-ghost btn-sm" id="pl-refresh">⟳</button>
        </div>
      </div>
      <div class="crud-filters">
        <input type="text" class="inp" id="f-search" placeholder="Tìm mã HĐ gốc, mã PL, nhà thầu…" style="min-width:280px">
      </div>
      <div id="pl-table" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>
      <div id="pl-modal" class="modal-overlay" style="display:none"></div>
    </div>`;
}

async function initPhuLuc() {
  _state.user = await getCurrentUser();
  try {
    const { data } = await supabase.from('ifrs_rules').select('loai_cp, note').order('loai_cp');
    _state.loaiCPList = (data || []).map(r => ({ loai_cp: r.loai_cp, mo_ta: r.note }));
  } catch (e) { _state.loaiCPList = []; }
  document.getElementById('pl-new').addEventListener('click', () => openForm());
  document.getElementById('pl-refresh').addEventListener('click', load);
  document.getElementById('f-search').addEventListener('input', renderTable);
  await load();

  // Auto-open form if prefill parent set from HD list quick action
  const prefill = sessionStorage.getItem('vnec_prefill_parent_pl');
  if (prefill) {
    sessionStorage.removeItem('vnec_prefill_parent_pl');
    setTimeout(() => openForm(prefill), 100);
  }
}

async function load() {
  try {
    const { data, error } = await supabase.from('plhd')
      .select('*').is('deleted_at', null).order('created_at', { ascending: false }).limit(2000);
    if (error) throw error;
    const groups = new Map();
    (data || []).forEach(r => {
      const key = r.ma_hd || r.so_plhd;
      if (!key) return;
      if (!groups.has(key)) {
        groups.set(key, {
          ma_hd: key, nha_thau: r.nha_thau, trang_thai: r.trang_thai,
          created_by: r.created_by, created_at: r.created_at, so_dong: 0, tong_tt: 0,
          parent: r.ma_hd_goc || (key.includes('/PL-') ? key.split('/PL-')[0] : '')
        });
      }
      const g = groups.get(key);
      g.so_dong++;
      g.tong_tt += parseFloat(r.thanh_tien || 0) || 0;
    });
    _state.rows = Array.from(groups.values());
    renderTable();
  } catch (e) {
    document.getElementById('pl-table').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTable() {
  const q = (document.getElementById('f-search').value || '').toLowerCase();
  const rows = _state.rows.filter(r =>
    !q || (r.ma_hd || '').toLowerCase().includes(q) || (r.nha_thau || '').toLowerCase().includes(q)
  );
  if (!rows.length) { document.getElementById('pl-table').innerHTML = '<div class="empty">Chưa có phụ lục</div>'; return; }

  let html = '<table class="tbl"><thead><tr><th>Mã PL</th><th>HĐ gốc</th><th>Nhà thầu</th><th class="c">Dòng</th><th class="r">Tổng GT</th><th class="c">Trạng thái</th><th class="c">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr>
      <td><b>${escH(r.ma_hd)}</b></td>
      <td class="small">${escH(r.parent)}</td>
      <td>${escH(r.nha_thau || '')}</td>
      <td class="c">${r.so_dong}</td>
      <td class="r money">${formatVND(r.tong_tt)}</td>
      <td class="c">${stBadge(r.trang_thai)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="view" data-key="${escH(r.ma_hd)}">Xem</button>
        ${r.trang_thai === 'draft' ? `<button class="btn-mini submit" data-act="submit" data-key="${escH(r.ma_hd)}">Gửi duyệt</button>` : ''}
        ${r.trang_thai === 'draft' ? `<button class="btn-mini reject" data-act="delete" data-key="${escH(r.ma_hd)}">Xóa</button>` : ''}
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('pl-table').innerHTML = html;

  document.querySelectorAll('#pl-table button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      const act = btn.dataset.act;
      const key = btn.dataset.key;
      if (act === 'view') viewPL(key);
      else if (act === 'delete') doDelete(key);
      else if (act === 'submit') doSubmit(key);
    });
  });
}

async function openForm(prefillMaHd = null) {
  const modal = document.getElementById('pl-modal');
  modal.style.display = 'flex';

  // v9.1 FIX: Parent từ hop_dong, loại trừ HDNT
  const { data: parents, error: pErr } = await supabase.from('hop_dong')
    .select('id, so_hd, ma_hd, nha_thau, ma_du_an, phan_loai_hd')
    .eq('trang_thai', 'approved')
    .is('deleted_at', null)
    .limit(500);

  if (pErr) {
    modal.innerHTML = `<div class="modal-box"><div class="m-body"><div class="error-box">Lỗi tải HĐ: ${pErr.message}</div></div></div>`;
    return;
  }

  const parentList = (parents || []).filter(p => {
    const pl = String(p.phan_loai_hd || '').toLowerCase();
    return !pl.includes('hdnt') && !pl.includes('nguyen') && !pl.includes('nguyên');
  });

  if (!parentList.length) {
    modal.innerHTML = `
      <div class="modal-box">
        <div class="m-hd"><div class="m-title">Không có HĐ phù hợp</div><button class="m-close" id="mc">×</button></div>
        <div class="m-body">
          <p>Không tìm thấy HĐ nào ở trạng thái <b>approved</b> và không phải HĐ Nguyên tắc. Phụ lục chỉ tạo được cho HĐ Gộp đã duyệt.</p>
        </div>
      </div>`;
    document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
    return;
  }

  const lcpOpts = _state.loaiCPList.map(r =>
    `<option value="${esc(r.loai_cp)}">${esc(r.loai_cp)}${r.mo_ta ? ' — ' + esc(r.mo_ta) : ''}</option>`
  ).join('');

  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">Tạo phụ lục hợp đồng mới</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <form id="pl-form">
          <div class="fg">
            <label class="field"><span>HĐ gốc *</span>
              <select name="parent" class="inp" required id="sel-parent">
                <option value="">— Chọn HĐ đã duyệt —</option>
                ${parentList.map(p => `<option value="${escH(p.so_hd || p.ma_hd)}" data-ma-du-an="${escH(p.ma_du_an || '')}" data-ncc="${escH(p.nha_thau || '')}">${escH(p.so_hd || p.ma_hd)} — ${escH(p.nha_thau || '')}</option>`).join('')}
              </select>
            </label>
            <label class="field"><span>Nhà thầu</span><input name="nha_thau" class="inp" id="inp-ncc" required></label>
          </div>
          <div class="rows-hd"><h4>Hạng mục phụ lục</h4><button type="button" class="btn btn-ghost btn-sm" id="add-row">+ Thêm dòng</button></div>
          <table class="rows-tbl">
            <thead><tr>
              <th style="width:30px">#</th>
              <th>Nội dung</th>
              <th style="width:80px">ĐVT</th>
              <th class="r" style="width:90px">SL</th>
              <th class="r" style="width:130px">Đơn giá</th>
              <th class="r" style="width:130px">Thành tiền</th>
              <th style="width:160px">Loại CP *</th>
              <th style="width:30px"></th>
            </tr></thead>
            <tbody id="rows-body"></tbody>
            <tfoot><tr class="ttl"><td colspan="5" class="r">TỔNG</td><td class="r money" id="total-cell">0</td><td colspan="2"></td></tr></tfoot>
          </table>
          <div class="modal-actions">
            <button type="button" class="btn btn-ghost" id="cancel">Hủy</button>
            <button type="submit" class="btn btn-primary">Lưu nháp</button>
          </div>
        </form>
      </div>
    </div>`;

  const body = document.getElementById('rows-body');
  addRowToForm(body, lcpOpts);

  document.getElementById('sel-parent').addEventListener('change', e => {
    const opt = e.target.selectedOptions[0];
    document.getElementById('inp-ncc').value = opt?.dataset?.ncc || '';
  });

  // Pre-select parent if from quick action
  if (prefillMaHd) {
    const sel = document.getElementById('sel-parent');
    sel.value = prefillMaHd;
    if (sel.value === prefillMaHd) {
      sel.dispatchEvent(new Event('change'));
    } else {
      // ma_hd not in approved-and-not-HDNT list — show warning
      const warn = document.createElement('div');
      warn.className = 'error-box';
      warn.style.margin = '8px 0';
      warn.innerHTML = `⚠️ HĐ <b>${escH(prefillMaHd)}</b> không nằm trong danh sách HĐ được tạo phụ lục (chưa duyệt hoặc là HDNT)`;
      sel.closest('.fg').after(warn);
    }
  }

  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('cancel').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('add-row').addEventListener('click', () => addRowToForm(body, lcpOpts));
  document.getElementById('pl-form').addEventListener('submit', e => { e.preventDefault(); submitForm(); });
}

function addRowToForm(body, lcpOpts) {
  const tr = document.createElement('tr');
  const idx = body.children.length + 1;
  tr.innerHTML = `
    <td class="c">${idx}</td>
    <td><input class="inp" name="noi_dung" required></td>
    <td><input class="inp" name="don_vi" placeholder="VD: m3"></td>
    <td><input class="inp r" name="so_luong" value="1"></td>
    <td><input class="inp r" name="don_gia"></td>
    <td><input class="inp r" name="thanh_tien" readonly style="background:#F4F4FB"></td>
    <td><select class="inp" name="loai_cp" required><option value="">-- Chọn --</option>${lcpOpts}</select></td>
    <td class="c"><button type="button" class="btn-mini reject" data-act="del">×</button></td>`;
  body.appendChild(tr);
  const sl = tr.querySelector('[name="so_luong"]');
  const dg = tr.querySelector('[name="don_gia"]');
  const tt = tr.querySelector('[name="thanh_tien"]');
  const calc = () => {
    tt.value = formatVND(parseVND(sl.value) * parseVND(dg.value));
    updateTotal(body);
  };
  sl.addEventListener('input', calc);
  dg.addEventListener('input', calc);
  tr.querySelector('[data-act="del"]').addEventListener('click', () => {
    tr.remove();
    [...body.children].forEach((el, i) => el.children[0].textContent = i + 1);
    updateTotal(body);
  });
}

function updateTotal(body) {
  let total = 0;
  body.querySelectorAll('[name="thanh_tien"]').forEach(i => total += parseVND(i.value));
  const cell = document.getElementById('total-cell');
  if (cell) cell.textContent = formatVND(total);
}

async function submitForm() {
  const fd = new FormData(document.getElementById('pl-form'));
  const parent = fd.get('parent');
  const nha_thau = (fd.get('nha_thau') || '').trim();
  if (!parent) { toast('Chọn HĐ gốc', 'err'); return; }

  const selParent = document.getElementById('sel-parent');
  const ma_du_an = selParent.selectedOptions[0]?.dataset?.maDuAn || null;

  const body = document.getElementById('rows-body');
  let hasMissingLcp = false;
  const rows = [...body.children].map((tr, i) => {
    const lcp = tr.querySelector('[name="loai_cp"]').value;
    const nd = tr.querySelector('[name="noi_dung"]').value.trim();
    if (nd && !lcp) hasMissingLcp = true;
    const sl = parseVND(tr.querySelector('[name="so_luong"]').value);
    const dg = parseVND(tr.querySelector('[name="don_gia"]').value);
    return {
      sort_order: i,
      noi_dung: nd,
      don_vi: tr.querySelector('[name="don_vi"]').value.trim() || null,
      so_luong: sl,
      don_gia: dg,
      thanh_tien: sl * dg,
      loai_cp: lcp || null
    };
  }).filter(r => r.noi_dung);

  if (hasMissingLcp) { toast('Có dòng thiếu Loại CP', 'err'); return; }
  if (!rows.length) { toast('Thêm ít nhất 1 hạng mục', 'err'); return; }

  try {
    const maPL = await getNextMaPL(parent);
    const tongTT = rows.reduce((s, r) => s + r.thanh_tien, 0);

    // KHÔNG set created_by — trigger trg_default_created_by tự fill UUID
    const payload = rows.map(r => ({
      so_plhd: maPL + '-' + (r.sort_order + 1),
      ma_hd: maPL,
      ma_hd_goc: parent,
      nha_thau: nha_thau || null,
      ma_du_an,
      noi_dung: r.noi_dung,
      don_vi: r.don_vi,
      so_luong: r.so_luong,
      don_gia: r.don_gia,
      thanh_tien: r.thanh_tien,
      loai_cp: r.loai_cp,
      trang_thai: 'draft'
    }));

    const { error } = await supabase.from('plhd').insert(payload);
    if (error) throw error;

    toast('Đã tạo phụ lục: ' + maPL + ' (' + rows.length + ' dòng, tổng ' + formatVND(tongTT) + ')', 'ok');
    document.getElementById('pl-modal').style.display = 'none';
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function viewPL(ma_hd) {
  const { data } = await supabase.from('plhd').select('*').eq('ma_hd', ma_hd).is('deleted_at', null);
  const items = data || [];
  const modal = document.getElementById('pl-modal');
  modal.style.display = 'flex';
  let total = 0;
  const rowsHtml = items.map((it, i) => {
    const tt = parseFloat(it.thanh_tien) || 0; total += tt;
    return `<tr><td class="c">${i + 1}</td><td>${escH(it.noi_dung || '')}</td><td>${escH(it.don_vi || '')}</td><td class="r">${formatVND(it.so_luong)}</td><td class="r">${formatVND(it.don_gia)}</td><td class="r money">${formatVND(tt)}</td><td>${escH(it.loai_cp || '')}</td></tr>`;
  }).join('');
  modal.innerHTML = `
    <div class="modal-box modal-lg">
      <div class="m-hd"><div class="m-title">Chi tiết: ${escH(ma_hd)}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <table class="mt"><thead><tr><th>#</th><th>Nội dung</th><th>ĐVT</th><th class="r">SL</th><th class="r">Đơn giá</th><th class="r">Thành tiền</th><th>Loại CP</th></tr></thead>
        <tbody>${rowsHtml}<tr class="ttl"><td colspan="5" class="r">TỔNG</td><td class="r money">${formatVND(total)}</td><td></td></tr></tbody></table>
      </div>
    </div>`;
  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
}

async function doDelete(ma_hd) {
  if (!confirm(`Xóa ${ma_hd}?`)) return;
  try {
    const { error } = await supabase.from('plhd').update({ deleted_at: new Date().toISOString() }).eq('ma_hd', ma_hd);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

async function doSubmit(ma_hd) {
  if (!confirm(`Gửi duyệt ${ma_hd}?`)) return;
  try {
    // Lấy tất cả id của các row plhd cùng ma_hd ở trạng thái draft
    const { data: drafts, error: gErr } = await supabase.from('plhd')
      .select('id').eq('ma_hd', ma_hd).eq('trang_thai', 'draft').is('deleted_at', null);
    if (gErr) throw gErr;
    if (!drafts || !drafts.length) throw new Error('Không có dòng nào ở trạng thái draft');
    const expected = drafts.length;

    // Submit row đầu để gọi RPC (audit log + state transition)
    await submitForApproval('plhd', drafts[0].id);

    // Bulk update các row còn lại — count để verify đầy đủ
    const { count, error: uErr } = await supabase.from('plhd')
      .update({ trang_thai: 'pending_l1' }, { count: 'exact' })
      .eq('ma_hd', ma_hd).eq('trang_thai', 'draft').is('deleted_at', null);
    if (uErr) throw uErr;

    // expected - 1 vì row đầu đã được submit qua RPC
    const remaining = expected - 1;
    if (count !== null && count < remaining) {
      toast(`⚠️ Chỉ submit được ${count + 1}/${expected} dòng (RLS chặn ${remaining - count} dòng)`, 'err');
    } else {
      toast(`Đã gửi duyệt ${expected} dòng`, 'ok');
    }
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

// v9.1: lowercase state badges
function stBadge(st) {
  const map = {
    draft:       ['Nháp',     'draft'],
    pending_l1:  ['Chờ L1',   'pending'],
    pending_l2:  ['Chờ L2',   'l1'],
    approved:    ['Đã duyệt', 'approved'],
    rejected:    ['Từ chối',  'rejected'],
    cancelled:   ['Đã hủy',   'draft']
  };
  const [lb, cls] = map[st] || ['—', 'draft'];
  return `<span class="badge-st badge-${cls}">${lb}</span>`;
}

function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
